"use client";

import React, { useState } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { Pagination } from "@nextui-org/react";

const CustomPagination = ({ total, count }) => {
  const router = useRouter();
  const searchParams = useSearchParams();

  let page = searchParams.get("page") || 1;
  page = Number(page);

  const [currentPage, setCurrentPage] = useState(1);

  const pageCount = Math.ceil(total / count);

  const handlePageChange = (props) => {
    if (typeof window !== "undefined") {
      let queryParams = new URLSearchParams(window.location.search);

      if (queryParams.has("page")) {
        queryParams.set("page", props);
      } else {
        queryParams.append("page", props);
      }

      const path = window.location.pathname + "?" + queryParams.toString();
      setCurrentPage(props)
      router.push(path);
    }
  };

  return (
    <div className="flex items-center justify-center">
      {pageCount > 1 && (
        <Pagination
          isCompact
          showControls
          total={pageCount}
          initialPage={1}
          color="primary"
          page={currentPage}
          onChange={handlePageChange}
          className="bg-white rounded-large"
        />
      )}
    </div>
  );
};

export default CustomPagination;
